<template>
  <transition name="run">
    <div id="AdvancedOptions"
         ref="container">
      <div class="title flex jb ac">
        <div class="title_left flex jb ac">
          <img src="./img/icon_img47.png"/>
          <span>高级选项</span>
        </div>
        <img src="./img/close.png"
             @click="close"
             class="close"/>
      </div>
      <div class="content_area">
        <div class="flex fc ac as">
          <div class="options_item">
            <div class="item_title flex jb ac ">
              <div class="text">
                图片质量
              </div>
            </div>
            <div class="item_con">
              <div class="quality">
                <div @click="form.quality=item.num" v-for="(item) in qualityImg" :class="item.num===form.quality?'quality_btns':'quality_btn'">
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div class="brief">
              {{ form.quality===0?'标准':'高清' }}绘图质量，需消耗{{ form.quality===0?'2':'4' }}积分
            </div>
          </div>
          <div class="options_item">
            <div class="item_title flex jb ac ">
              <div class="text">
                生成尺寸
              </div>
            </div>
            <div class="brief">
              选择生成图像的宽度×高度比例
            </div>
            <div class="item_con">
              <div class="size_list flex ac">
                <div class="size_item flex fc jc ac"
                     :class="form.aspect==item.size?'active':''"
                     @click="choose_aspect(item)"
                     v-for="(item,index) in img_size"
                     :key="index">
                  <img :src="require('./img/s'+(index+1)+'.png')"/>
                  <p>{{ item.size }}</p>
                  <p>{{ item.title }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      fileList: [],
      iw_options: [
        {
          label: '关闭iw选项',
          value: '0'
        },
        {
          label: '--iw 0.25 相似度30%',
          value: '0.25'
        },
        {
          label: '--iw 0.5 相似度40%',
          value: '0.5'
        },
        {
          label: '--iw 1 相似度50%',
          value: '1'
        },
        {
          label: '--iw 1.25 相似度60%',
          value: '1.25'
        },
        {
          label: '--iw 1.5 相似度70%',
          value: '1.5'
        },
        {
          label: '--iw 1.75 相似度80%',
          value: '1.75'
        },
        {
          label: '--iw 2 相似度90%',
          value: '2'
        },
      ],
      img_size: [
        {
          size: '1:1',
          title: '头像框'
        },
        {
          size: '1:2',
          title: '手机壁纸'
        },
        {
          size: '16:9',
          title: '电脑壁纸'
        },
        {
          size: '9:16',
          title: '宣传海报'
        },
        {
          size: '4:3',
          title: '文章配图'
        },
        {
          size: '3:4',
          title: '媒体配图'
        },
        {
          size: '3:2',
          title: '横版名片'
        },
        {
          size: '2:3',
          title: '小红书图'
        },
      ],
      form: {
        iw: 0.25,
        aspect: "16:9",// 大小比例
        is_public: '0',//是否公开作品
        // tips_text:"",
        quality: 0,
        stylize: 100,
        chaos: 100,
        upload_list: []
      },
      fileApi: FILE_API_SERVER,
      upoadLoading: false,
      uploadError: '',
      okNum: 0,
      totalNum: 0,

      qualityImg: [
        {
          name: '标准',
          num: 0,
        },
        {
          name: '高清',
          num: 100,
        },
      ],
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    hav_choose_tips() {
      return this.$store.state.hav_choose_tips
    }
  },
  created() {

  },
  mounted() {
    setTimeout(() => {
      document.addEventListener('click', this.handleDocumentClick);
      let _form = this.getCache("formAdvanceParams") || ""
      if (_form) {
        this.form = JSON.parse(_form)
      }
    }, 100)
  },
  methods: {
    checkLogin() {
      // 检查登录状态
      this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.commit('setUserInfo', null)
        this.$store.commit('setIsLogin', false)
        this.$store.commit('setShowLogin', true)
      }).catch(() => {
      });

    },
    initData() {
      this.setCache("formAdvanceParams", JSON.stringify(this.form), 60 * 60 * 1000)
    },
    choose_aspect(item) {
      this.form.aspect = item.size
      console.log(item.size)
      console.log(this.form.aspect)
    },
    close() {
      this.$emit('close',this.form)
    },
    handleDocumentClick(event) {
      // 判断点击的区域是否是 container 元素或其子元素
      let dom = document.getElementById("tips_words")
      if (dom) {
        return;
      } else if (event.target.id == "tips") {
        return;
      }
      if (this.$refs.container && !this.$refs.container.contains(event.target)) {
        // return
        // 点击了除 container 以外的区域，执行相应操作
        this.setCache("formAdvanceParams", JSON.stringify(this.form), 60 * 60 * 1000)
        this.$emit('close', this.form)
      }
    },
    crefChange(index) {
      // cref 变化
      if (this.form.upload_list[index].is_cref) {
        let k = 0
        this.form.upload_list.forEach(e => {
          if (k != index) {
            this.form.upload_list[k].is_cref = false
          }
          k += 1
        })
      }
    },
    deleteUpload(index) {
      if (this.upoadLoading) {
        this.$message.error("正在上传，请稍后再操作！")
        return
      }
      let i = -1
      for (let k = 0; k < this.$refs.uploadImg.uploadFiles.length; k++) {
        if (this.form.upload_list[index].lastModified == this.$refs.uploadImg.uploadFiles[k].raw.lastModified) {
          i = k
        }

      }
      this.form.upload_list.splice(index, 1)
      this.fileList.splice(i, 1)
      this.$nextTick(() => {
        this.totalNum = this.$refs.uploadImg.uploadFiles.length;
      })
    },
    handleChange(file, fileList) {
      if (this.upoadLoading) {
        this.$message.error("正在上传，请稍后再操作！")
        return
      }

      if (this.form.upload_list.length >= 4) {
        return
      }
      if (file.raw.type != "image/jpeg" && file.raw.type != "image/png") {
        this.$message({
          message: '仅支持JPG、PNG格式图片',
          type: 'warning'
        })
        this.$refs.uploadImg.clearFiles()
        this.totalNum = this.$refs.uploadImg.uploadFiles.length;
        return
      }
      if (file.size > 10 * 1024 * 1024) {
        this.$message({
          message: '请上传10M以内的图片',
          type: 'warning'
        })
        this.$refs.uploadImg.clearFiles()
        this.totalNum = this.$refs.uploadImg.uploadFiles.length;
        return
      }

      let img_src = URL.createObjectURL(file.raw);
      let flag = true
      this.form.upload_list.forEach(e => {
        if (e.lastModified == file.raw.lastModified) {
          flag = false
        }
      })
      if (flag) {
        this.form.upload_list.push({
          img_src: img_src,
          img_url: "",
          sref: 0,
          is_sref: 0,
          cref: 0,
          is_cref: 0,
          lastModified: file.raw.lastModified
        })
      } else {
        this.$message.error("请勿上传重复图片")
      }
      this.totalNum = this.$refs.uploadImg.uploadFiles.length;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 4 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    handleSuccess(response, file, fileList) {
      console.log("handleSuccess", response, file)
    },
    async submitUpload() {
      this.okNum = 0
      this.totalNum = this.$refs.uploadImg.uploadFiles.length;
      if (this.totalNum <= 0) {
        this.$message.error("没有需要上传的文件")
        return
      }
      this.upoadLoading = true
      for (let index = 0; index < this.$refs.uploadImg.uploadFiles.length; index++) {
        this.okNum += 1
        const f = this.$refs.uploadImg.uploadFiles[index];
        await this.uploadFile(f)
      }
      this.$refs.uploadImg.clearFiles()
      this.totalNum = this.$refs.uploadImg.uploadFiles.length;
      this.upoadLoading = false
      this.$message.success("图片上传完成！")
    },
    async uploadFile(file) {
      let lastModified = file.raw.lastModified
      this.uploadError = ""
      let post_url = await this.$http.get(`${FILE_API_SERVER}/api/front/upload/?file_folder=mj_iw`).then(res => {
        return res.data
      }).catch(e => {
        return ""
      });
      if (!post_url) {
      }
      // 上传图片
      let formData = new FormData();
      formData.append("file", file.raw, file.name);
      let fileResponse = await this.$http.post(post_url, formData, {
        headers: {"Content-Type": "multipart/form-data"},
        responseType: "text"
      }).then(res => {
        return eval(res);
      }).catch(e => {
        return "";
      });
      this.uploadError = fileResponse.data.error
      let file_full_url = fileResponse.data.file_full_url
      this.form.upload_list.forEach(e => {
        if (e.lastModified == lastModified) {
          e.img_url = file_full_url
          e.img_src = file_full_url
        }
      })
    },
    add_tips() {
      this.$store.commit('setTipsCom', true)
    },
    handleDeleteTipsWords(item, index) {
      console.log(item, index)
      this.hav_choose_tips.splice(index, 1)
    },
    clear_tips() {
      this.$store.commit('setChooseTips', [])
    }
  },
  beforeDestory() {
    document.removeEventListener('click', this.handleDocumentClick);
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.fg1 {
  flex: 1;
}

.run-enter {
  transform: translateY(-100%);
  opacity: 0;
}

.run-enter-to {
  transform: translateY(0);
  opacity: 1;
}

.run-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

.run-enter-active,
.run-leave-active {
  transition: all 0.2s linear 0s;
}

#AdvancedOptions {
  position: absolute;
  z-index: -1;
  bottom: 95px;
  left: 0;
  right: 0;
  width: 100%;
  background-color: #1d2027;
  padding: 15px;
  border-radius: 6px;

  .title {
    padding-bottom: 10px;

    .title_left {
      opacity: 0.8;

      img {
        width: 16px;
        height: 16px;
        margin-right: 10px;
      }

      span {
        font-size: 16px;
        color: #fff;
      }
    }

    .close {
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
  }

  .content_area {
    overflow-y: auto;
    //height: 200px;

    .options_item {
      margin: 10px 0;

      .item_title {

        .text {
          font-size: 14px;
          color: #fff;
          position: relative;
          padding-left: 10px;

          &:before {
            content: "";
            width: 4px;
            height: 15px;
            background: #5865f2;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            border-radius: 4px;
          }
        }
      }

      .brief {
        font-size: 14px;
        margin: 8px 0;
      }

      .item_con {
        .el-switch {
          margin-left: 10px;
        }

        .quality {
          display: flex;
          color: #fff;
          font-size: 14px;

          .quality_btn {
            border: 2px solid #393c43;
            border-radius: 3px;
            background-color: #1d2027;
            padding: 10px 50px;
            margin: 10px 20px 0 0;
            cursor: pointer;
          }

          .quality_btns {
            border: 2px solid #5865f2;
            border-radius: 3px;
            background-color: #303245;
            padding: 10px 50px;
            margin: 10px 20px 0 0;
            cursor: pointer;
          }

        }


      }
    }
  }
}

.upload_area {
  .upload_demo {
    /deep/ .el-upload-dragger {
      width: 100%;
      height: 192px;
      background: transparent;
      border: 0;
    }

    .tips_text {
      height: 100%;

      .fg1 {
        padding: 0 30px;

        p {
          font-size: 14px;
          color: #fff;
        }

        span {
          color: #5865f2;
        }
      }

      .truncate {
        height: 60px;
        background: #000;
      }
    }
  }
}

.upload_item {
  width: 196px;
  height: 196px;
  background: transparent;
  border: 2px dashed #5e6166;
  background: #2b2d31;
  margin-right: 20px;
  border-radius: 8px;
  overflow: hidden;

  .truncate {
    width: 100%;
    padding: 0 8px;
    font-size: 12px;

    .flex {
      padding: 5px 0;
    }

    .sty {
      line-height: 20px;
      background: #5865f2;
      border-radius: 4px;
      color: #fff;
      padding: 0 5px;
      cursor: pointer;
    }

    P {
      /deep/ .el-switch__core {
        margin-left: 5px;
      }
    }
  }
}

.img_item {
  position: relative;

  .delete {
    position: absolute;
    right: 0;
    top: 0;
    padding: 5px;
    border-radius: 5px;
    cursor: pointer;

    img {
      width: 16px;
      height: 16px;
    }

    &:hover {
      background: #414246;
    }
  }

  .pic {
    width: 100%;
  }

  .truncate {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.67);
  }
}

.popover_box {
  p {
    font-size: 14px;
    color: #fff;
    text-align: center;
    margin-bottom: 5px;
  }

  .num_input {
    width: 100%;
    line-height: 28px;
    border: 1px solid #5865f2;
    border-radius: 4px;

    /deep/ .el-input-number__increase,
    /deep/ .el-input-number__decrease {
      background: transparent;
      border: none;
      color: #fff;
    }

    /deep/ .el-input__inner {
      height: 28px;
      line-height: 28px;
      border: 0;
      background: transparent;
      color: #fff;
      font-size: 14px;
    }
  }
}

.select_tips {
  width: 434px;
  margin-top: 10px;
  background: #242830;
  border-radius: 4px;
  padding: 0 10px;
  color: #cbcbcb;

  .text {
    font-size: 14px;

    img {
      width: 16px;
      height: 16px;
      margin-left: 5px;
    }
  }

  /deep/ .el-input__inner {
    background: transparent;
    border: 0;
  }
}

.btn_area {
  .btn {
    padding: 3px 8px;
    border-radius: 12px;
    font-size: 14px;
    margin-left: 5px;
    color: #5865f2;
    border: 1px solid #5865f2;
    cursor: pointer;
  }
}

.input_textarea {
  border: 1px solid #393c43;
  border-radius: 8px;
  margin: 10px 0;
  padding: 10px;

  .tags_list {
    width: 412px;
    height: 60px;
    display: flex;
    flex-wrap: wrap;
    overflow-y: auto;

    p {
      height: 24px;
      line-height: 22px;
      font-size: 14px;
      border: 1px solid #333;
      border-radius: 24px;
      padding: 0 10px;
      color: #fff;
      margin-bottom: 5px;

      span {
        font-size: 12px;
        margin-left: 2px;
        color: #949ba4;
        cursor: pointer;

        &:hover {
          color: #fff;
        }
      }
    }
  }

  .all_clear {
    font-size: 12px;
    color: #fff;
    opacity: 0.69;
    text-align: right;
    cursor: pointer;
  }
}

.size_list {
  .size_item {
    border: 2px solid #393c43;
    width: 70px;
    height: 100px;
    margin-right: 10px;
    border-radius: 2px;
    cursor: pointer;

    img {
      width: 36px;
      height: 40px;
    }

    p {
      font-size: 12px;
      color: #8e9093;
      margin-top: 6px;
    }

    &.active {
      border: 2px solid #5865f2;
    }
  }
}

.slider_area {
  .slider_item {
    margin-top: 10px;

    .tips {
      font-size: 14px;
      color: #fff;
    }

    .icon_tips {
      width: 16px;
      height: 16px;
      margin: 0 20px 0 5px;
      cursor: pointer;
    }

    .slider {
      width: 330px;
    }

    /deep/ .el-input-number__increase,
    /deep/ .el-input-number__decrease {
      background: #242830;
      border: none;
      color: #fff;
      width: 24px;
      height: 22px;
      line-height: 24px;
      color: #999;
    }

    /deep/ .el-slider__input {
      width: 90px;
      line-height: 26px;
    }

    /deep/ .el-input__inner {
      height: 26px;
      line-height: 26px;
      border: 0;
      background: #242830;
      color: #d4d4d4;
      font-size: 14px;
      padding-right: 29px;
      padding-left: 29px;
    }

    /deep/ .el-slider__runway {
      margin: 5px 120px 5px 0;
      top: 9px;
    }

    /deep/ .el-slider__button {
      border-color: #5865f2;
    }

    /deep/ .el-slider__bar {
      background: #5865f2;
    }
  }
}

.switch_area {
  .tips {
    margin-right: 118px;
  }
}

.popup {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1501;
  bottom: 0;
  left: 0;
  transition: all 0.3s;
  background: rgba(0, 0, 0, 0.8);
  overflow: auto;
  animation: fadeInSlowAni 0.3s 1;

  .centerPanel {
    position: fixed;
    z-index: 1501;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: transform 0.2s;
  }
}

.primary-button {
  cursor: pointer;
  background-color: #5865f2;
  color: #fff;
  border-radius: 10rpx;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  width: 240px;
  height: 40px;
  border-radius: 9999px;
  margin-top: 10px;

  &:hover {
    background-color: rgba(88, 101, 242, 0.867);
  }
}

/deep/ .el-loading-mask {
  background: none;
}
</style>